import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnixtimeService {

  unix_time: number;
  
  unixtime(){
    this.unix_time=Math.round(Date.now() / 1000);
    return this.unix_time;
  }

  constructor() { }
}
